import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import i18next from 'i18next';
import getReferralType from './getReferralType';

interface Props {
    profile: TypedMap<Profile>;
    onlyRefer?: boolean;
    countryCode: string;
    selectedType?: string;
}

const PrepareLandlineText = ({
    profile,
    countryCode,
    onlyRefer,
    selectedType,
}: Props) => {
    if (selectedType === 'number') {
        return 'number';
    }

    const referralType = getReferralType(profile);

    let secondaryText;

    if (referralType === 'hangup' || referralType === 'loop') {
        secondaryText = i18next.t(
            `settings.incoming_calls.profile.referal.${referralType}`,
        );
    } else if (referralType === 'voicemail') {
        secondaryText = i18next.t('settings.incoming_calls.delayed.voicemail');
    } else if (referralType === 'number') {
        if (onlyRefer) {
            secondaryText = i18next.t(
                'settings.incoming_calls.profile.referal.number',
            );
        } else {
            const redirectNumber = profile.getIn([
                'callForwarding',
                'unconditionalRedirect',
                'forwardingNumber',
                'number',
            ]);
            secondaryText = prettyFormatE164Number(redirectNumber, countryCode);
        }
    } else {
        secondaryText = i18next.t(
            'settings.incoming_calls.optionlist.' + referralType,
        );
    }

    if (onlyRefer) return secondaryText;

    return profile.getIn(['spokenNotification', 'referEntry', 'key'])
        ? i18next.t('settings.incoming_calls.profile.message') +
              ' + ' +
              secondaryText
        : secondaryText;
};

export default PrepareLandlineText;
